import { useNavigate } from "@remix-run/react";
import { CopyCheck, SmilePlus, Gauge, ArrowRight, Sheet } from "lucide-react";
import { Button } from "~/components/ui/button";

export default function WhyKnackSheetSection() {
  const navigate = useNavigate();

  return (
    <section className="container flex flex-col items-center gap-8">
      <div className="flex max-w-[642px] flex-col items-center text-pretty text-center">
        <h2 className="font-recursive text-4xl font-bold leading-normal">
          Why KnackSheet?
        </h2>
        <p className="font-recursive text-lg">
          Achieve more with less effort - empower your team with an interface
          that’s fast, familiar, and easy to install.
        </p>
      </div>
      <div className="grid max-w-[880px] grid-cols-1 grid-rows-1 gap-9 sm:grid-cols-2 lg:grid-cols-3">
        <div className="col-span-1 row-span-1 flex flex-col gap-2 rounded border border-emerald-500 bg-neutral-50 p-8">
          <CopyCheck className="h-12 w-12 text-emerald-500" />
          <div className="flex flex-col">
            <h3 className="font-recursive text-xl font-bold">Easy Setup</h3>
            <p>
              Quickly configure and install KnackSheet without the need for
              complex coding or additional resources.
            </p>
          </div>
        </div>
        <div className="col-span-1 row-span-1 flex flex-col gap-2 rounded border border-emerald-500 bg-neutral-50 p-8">
          <SmilePlus className="h-12 w-12 text-emerald-500" />
          <div className="flex flex-col">
            <h3 className="font-recursive text-xl font-bold">
              Increase User Adoption
            </h3>
            <p>
              Make your app easier to use, encouraging your team to adopt and
              stick with your Knack app.
            </p>
          </div>
        </div>
        <div className="col-span-1 flex h-full flex-col justify-between gap-2 rounded border border-emerald-500 bg-neutral-50 p-8 lg:row-span-2">
          <div className="flex flex-col gap-2">
            <Gauge className="h-12 w-12 text-emerald-500" />
            <div className="flex flex-col">
              <h3 className="font-recursive text-xl font-bold">
                Faster Data Management
              </h3>
              <p>
                Speed up your data entry process with a simple, spreadsheet-like
                interface that allows multiple updates at once.
              </p>
            </div>
          </div>
          <Button
            className="hidden h-fit w-full px-8 py-3 text-lg font-semibold leading-normal lg:flex"
            onClick={() => navigate("/login?try")}
          >
            Try now <ArrowRight className="ml-1 h-6 w-6" />
          </Button>
        </div>
        <div className="row-span-1 flex h-fit flex-col gap-2 rounded border border-emerald-500 bg-neutral-50 p-8 lg:col-span-2">
          <Sheet className="h-12 w-12 text-emerald-500" />
          <div className="flex flex-col">
            <h3 className="font-recursive text-xl font-bold">
              Intuitive Interface
            </h3>
            <p>
              Provide an easy-to-learn interface that gets users on board and
              keeps them using the Knack app you worked to build.
            </p>
          </div>
        </div>
        <Button
          className="col-span-1 flex h-fit w-full px-8 py-3 text-lg font-semibold leading-normal sm:col-span-2 lg:hidden"
          onClick={() => navigate("/login?try")}
        >
          Try now <ArrowRight className="ml-1 h-6 w-6" />
        </Button>
      </div>
    </section>
  );
}
